/**
 * Uses to push modules into the plugins.js up-front dependency list
 * Consider lazy-loading optional modules (e.g. analytics)
 */
define('componentLoader', ['componentHelper'], function(helper) {
  'use strict';
  /*
  *
  *
  *
  *
  *
  *
  * !!!!!! STOP !!!!!!
  *
  * Do not add ANYTHING ELSE INTO THIS FILE!
  * Simply add this to your component and your component will load via this file:
  *
  * data-component="componentName"
  *
  *
  * See this link for documentation: https://thehut.atlassian.net/wiki/display/FED/Using+the+Component+Loader
  *
  *
  *
  *
  *
  *
  */

  helper.reloadAllComponents();

  /**
   * Return ComponentHelper instance
   */
  return helper;
});
